/* Textarea adjustments */

textarea.af-autogrow {
  resize: none;
  overflow-y: hidden;
}
